import TransactionRisk from './TransactionRisk'

export default TransactionRisk
